<template>
  <portal to="MODAL">
    <vk-modal @close="closeModal">
      <vk-modal-body class="MODAL-WIDTH d-flex fd-row">
        <div class="p-l-3 p-l-2:mo p-t-3">
          <span class="INFORMATION-ICON">!</span>
        </div>
        <vk-modal-content class="MODAL-CONTENT">
          <div class="text-bold text-lg p-b-1 p-t-1">Active Occupations for Leads</div>
          <div>
            <div class="p-b-3 BODY">
              <div class="p-b-2">
                {{ activeMessage }} Would you like to add pause dates to your schedule?
              </div>
              <div>You may edit or remove the paused dates in the
                <router-link
                    :to="{ name:'dashboard::pro::agenda'}"
                    class="LINK">Schedule
                </router-link>
                tab.</div>
            </div>
            <vk-modal-footer class="MODAL-FOOTER jc-center m-b-2 p-t-0">
              <button
                  @click="closeModal"
                  class="btn-secondary btn-sm flex-0-0 m-r-2">No, Cancel
              </button>
              <button
                  @click="openPauseLeads"
                  class="btn btn-sm flex-0-0">Yes, Pause New Dates
              </button>
            </vk-modal-footer>
          </div>
        </vk-modal-content>
      </vk-modal-body>
    </vk-modal>
  </portal>
</template>

<script>
export default {

  name: 'active-leads-modal',
  components: {

  },
  props: {
    activeMessage: {
      type: String,
      requied: true,
    },
  },

  methods: {
    closeModal () {
      this.$emit('close');
    },
    openPauseLeads () {
      this.$emit('pause');
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .MODAL-WIDTH {
    @include responsive(width, 95vw, $unit * 50);
    height: auto;
  }
  .MODAL-CONTENT {
    display: flex;
    flex-direction: column;

    @include responsive(width, 95vw, $unit * 37.5);

    .LINK {
    color:#3E7697;
  }
  }
  .MODAL-FOOTER {
    display: flex;
    background-color: white;
  }
.INFORMATION-ICON {
  display: flex;
  justify-content: center;
  align-items: baseline;
  line-height: 1;
  border: #3E7697 solid 3px;
  color: #3E7697;
  font-weight: 900;
  padding-bottom:12px;

  @include circle(20px);
}
.BODY {
  font-size: 14px;
}
</style>
